// ** Returns paginated array
export const paginateArray = (array, perPage, page) => array.slice((page - 1) * perPage, page * perPage)

// ** Returns sorted array
export const sortCompare = key => (a, b) => {
  const fieldA = a[key]
  const fieldB = b[key]

  let comparison = 0
  if (fieldA > fieldB) {
    comparison = 1
  } else if (fieldA < fieldB) {
    comparison = -1
  }
  return comparison
}

// ** Returns number range using cryptographically secure random number generator
export const getRandomInt = (min, max) => {
  if (min > max) {
    const temp = max
    /* eslint-disable no-param-reassign */
    max = min
    min = temp
    /* eslint-enable */
  }

  // Use crypto.getRandomValues for cryptographically secure random numbers
  const array = new Uint32Array(1)
  crypto.getRandomValues(array)
  const randomFloat = array[0] / (0xffffffff + 1)

  if (min <= 0) {
    return Math.floor(randomFloat * (max + Math.abs(min) + 1)) + min
  }
  return Math.floor(randomFloat * max) + min
}

// ** Returns random date using cryptographically secure random number generator
export const randomDate = (start, end) => {
  const diff = end.getTime() - start.getTime()
  
  // Use crypto.getRandomValues for cryptographically secure random numbers
  const array = new Uint32Array(1)
  crypto.getRandomValues(array)
  const randomFloat = array[0] / (0xffffffff + 1)
  
  const newDiff = diff * randomFloat
  const date = new Date(start.getTime() + newDiff)
  return date
}
